<template>
    <div v-cloak class="configuration-wrapper">
        <div class="configuration-title" v-if="isAllowedToEdit">
            <h2>Centre Settings</h2>
            <button class="btn btn-light" v-if="isAllowedToEdit && !isEditable" v-on:click="toggleEditable">edit</button>
        </div>
        <ul class="configuration-list">
            <li v-for="(configuration, index) in centreConfigurations" :key="configuration.id">
                <centre-configuration-item
                 :is-editable="isEditable"
                 :value="centreConfigurations[index]"
                 :valueLabel="configuration.configuration_type.code === 'contractor_count' ? 'Current Number of Profiles' : ''" />
            </li>
        </ul>
        <button class="btn btn-light" v-if="isAllowedToEdit && isEditable" v-on:click="saveConfigurations">Save</button>
        <button class="btn btn-danger" v-if="isAllowedToEdit && isEditable" v-on:click="cancel">Cancel</button>
    </div>
</template>

<script>
import Configurations from "../Services/Configurations";
import CentreConfigurationItem from './UI/CentreConfigurationItem.vue';

export default {
        components: { CentreConfigurationItem },
        name: "CentreConfigurationComponent",
        props: {
            isAllowedToEdit: Boolean,
            centreId: Number,
        },
        data: function()  {
            return {
                centreConfigurations: [],
                isEditable: false,
            }
        },
        mounted() {
            this.getCentreConfigurations();
        },
        methods: {

            getCentreConfigurations:  function() {
                Configurations.getCentreConfigurations(this.centreId).then((configurations) => {
                    this.centreConfigurations = configurations;
                });
            },

            setCentreConfiguration: function(configuration) {
                Configurations.setCentreConfiguration(configuration, this.centreId).then((configurations) => {
                    this.centreConfigurations = configurations;
                }).catch((error) => {
                    this.getCentreConfigurations();
                    console.log(error.response);
                })
            },

            cancel: function() {
              this.isEditable = false;
              this.getCentreConfigurations();
            },

            saveConfigurations: function() {

                let confirmation = confirm("These settings will be applied for the centre.\n" +
                    "\n" +
                    "Are you sure you want to continue?");

                if (!confirmation) {
                    return false;
                }

                this.centreConfigurations.forEach((configuration) => {
                   this.setCentreConfiguration(configuration);
                });

                this.isEditable = false;
            },

            toggleEditable: function() {
                this.isEditable = !this.isEditable;
            }
        }
    }
</script>

<style scoped>

    .ui-toggle-switch {
        float: left;
        width: 60px;
        height: 28px;
    }

    .configuration-list {
        list-style: none;
        padding: 0px;
        margin-bottom: 20px;
        margin-top: 20px;
    }

    .configuration-title {
        display: inline-flex;
        margin-top: 40px;
    }

    .configuration-title h2 {
        margin-right: 10px;
    }

    .btn {
        height: 28px;
        line-height: 28px;
        margin: 0px;
        padding-top: 0px;
    }
</style>
